import {Box, Table, TableBody, TableCell, TableHead, TableRow, useMediaQuery} from "@mui/material";
import React from "react";
import {Link, useParams} from "react-router-dom";
import * as specificationApi from "../../api/equipmentApi/specificationApi";
import MWCaption from "../../components/MWCaption";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";
import {useGetItemQuery} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import {EQSpecification} from "../../models/serverModels/equipment/EQSpecification";
import {
  DetailSubMenuGroup,
  StyledDetailContainer,
  StyledDetailTable,
  StyledImageBox,
} from "../../styledComponents/StyledDetail";

import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DetailsIcon from "@mui/icons-material/Details";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import {useRecoilValue} from "recoil";
import {levelSelector, tokenSelector} from "../../Recoil/Atom/authState";
import ActionButtonGroup from "../../components/ActionButtonGroup";
import MWSpeedDial from "../../components/MWSpeedDial";
import {
  adminCreateEquipmentActionButton,
  createControlActionButton,
  createControlSpeedDial,
  createEquipmentActionButton,
} from "../../models/clientModels/data/actionButtonData";
import {StickyContainer} from "../../styledComponents/StyledListContainer";

const EquipmentDetail = () => {
  let {id} = useParams();

  const tokenState = useRecoilValue(tokenSelector);
  const userLevel = useRecoilValue(levelSelector);

  const isMobile = useMediaQuery("(min-width: 960px)");

  const {data, isLoading, isFetching} = useGetItemQuery<ResponseItem<EQSpecification>>({
    key: ["equipmentDetail", id],
    api: () => specificationApi.getItem({id: parseInt(id!), token: tokenState}),
  });
  return (
    <React.Fragment>
      <StickyContainer>
        <SubTitle subTitle="설비제원 상세" />
        {isMobile ? (
          <DetailSubMenuGroup>
            <ActionButtonGroup data={createControlActionButton(parseInt(id!))} />
            <ActionButtonGroup
              data={
                userLevel === 4
                  ? createEquipmentActionButton(parseInt(id!), tokenState)
                  : adminCreateEquipmentActionButton(parseInt(id!), tokenState)
              }
            />
          </DetailSubMenuGroup>
        ) : (
          <MWSpeedDial actions={createControlSpeedDial(parseInt(id!), tokenState)} />
        )}
      </StickyContainer>
      <StyledDetailContainer>
        <MWCaption title={"상세정보"} color="#01579B" icon={<DetailsIcon />} />
        <StyledDetailTable>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell colSpan={8} align="center" className="subTitle">
                  설비이력카드
                </TableCell>
              </TableRow>
            </TableHead>
            {isLoading && isFetching ? (
              <TableBody>
                <MWSkeleton row={12} column={4} />
              </TableBody>
            ) : isMobile ? (
              <TableBody>
                <TableRow>
                  <TableCell component="th">공정명</TableCell>
                  <TableCell>{data?.item?.installLocation}</TableCell>
                  <TableCell component="th">PSM유무</TableCell>
                  <TableCell>{data?.item?.isPSM ? "PSM 대상" : "PSM 비대상"}</TableCell>
                  <TableCell component="th">설비책임자</TableCell>
                  <TableCell>{data?.item?.personName}</TableCell>
                  <TableCell component="th">설비등급</TableCell>
                  <TableCell>{data?.item?.eqLevel}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비번호</TableCell>
                  <TableCell>{data?.item?.identifyNumber}</TableCell>
                  <TableCell component="th">법적대상</TableCell>
                  <TableCell>{data?.item?.law}</TableCell>
                  <TableCell component="th">설비명</TableCell>
                  <TableCell>{data?.item?.name}</TableCell>
                  <TableCell component="th">점검(교정)주기</TableCell>
                  <TableCell>{data?.item?.checkTermMonth}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">점검기준일</TableCell>
                  <TableCell>{`${new Date(data?.item?.nextDate!).getFullYear()}년 ${
                    new Date(data?.item?.nextDate!).getMonth() + 1
                  }월 ${new Date(data?.item?.nextDate!).getDate()}일`}</TableCell>
                  <TableCell component="th">제작사</TableCell>
                  <TableCell>{data?.item?.manufacture}</TableCell>
                  <TableCell component="th">설치일자</TableCell>
                  <TableCell>
                    {`${new Date(data?.item?.installDate!).getFullYear()}년 ${
                      new Date(data?.item?.installDate!).getMonth() + 1
                    }월 ${new Date(data?.item?.installDate!).getDate()}일`}
                  </TableCell>
                  <TableCell component="th">Model</TableCell>
                  <TableCell>{data?.item?.modelNo}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">방폭등급</TableCell>
                  <TableCell>{data?.item?.wideLevel}</TableCell>
                  <TableCell component="th">Serial No</TableCell>
                  <TableCell>{data?.item?.serialNo}</TableCell>
                  <TableCell component="th">압력(운전/설계)</TableCell>
                  <TableCell>{data?.item?.drivePressure}</TableCell>
                  <TableCell component="th">압력(운전/설계)</TableCell>
                  <TableCell>{data?.item?.designPressure}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">구매금액(천원) </TableCell>
                  <TableCell>{data?.item?.price}</TableCell>
                  <TableCell component="th">용량</TableCell>
                  <TableCell>{data?.item?.capacity}</TableCell>
                  <TableCell component="th">온도(운전/설계)⁰C</TableCell>
                  <TableCell>{data?.item?.driveTemperature}</TableCell>
                  <TableCell component="th">온도(운전/설계)⁰C</TableCell>
                  <TableCell>{data?.item?.designTemperature}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">점검 정비 절차서 </TableCell>
                  <TableCell>해당없음</TableCell>
                  <TableCell component="th">관련도서(인증서) </TableCell>
                  <TableCell>해당없음</TableCell>
                  <TableCell component="th">관련P&ID</TableCell>
                  <TableCell>해당없음</TableCell>
                  <TableCell component="th">해당없음</TableCell>
                  <TableCell>해당없음</TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell component="th" width="30%">
                    공정명
                  </TableCell>
                  <TableCell width="70%">{data?.item?.installLocation}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">PSM유무</TableCell>
                  <TableCell>{data?.item?.isPSM ? "PSM 대상" : "PSM 비대상"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비책임자</TableCell>
                  <TableCell>{data?.item?.personName}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비등급</TableCell>
                  <TableCell>{data?.item?.eqLevel}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비번호</TableCell>
                  <TableCell>{data?.item?.identifyNumber}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">법적대상</TableCell>
                  <TableCell>{data?.item?.law}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설비명</TableCell>
                  <TableCell>{data?.item?.name}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">점검(교정)주기</TableCell>
                  <TableCell>{data?.item?.checkTermMonth}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">점검기준일</TableCell>
                  <TableCell>{`${new Date(data?.item?.nextDate!).getFullYear()}년 ${
                    new Date(data?.item?.nextDate!).getMonth() + 1
                  }월 ${new Date(data?.item?.nextDate!).getDate()}일`}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">제작사</TableCell>
                  <TableCell>{data?.item?.manufacture}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">설치일자</TableCell>
                  <TableCell>
                    {`${new Date(data?.item?.installDate!).getFullYear()}년 ${
                      new Date(data?.item?.installDate!).getMonth() + 1
                    }월 ${new Date(data?.item?.installDate!).getDate()}일`}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Model</TableCell>
                  <TableCell>{data?.item?.modelNo}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">방폭등급</TableCell>
                  <TableCell>{data?.item?.wideLevel}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">Serial No</TableCell>
                  <TableCell>{data?.item?.serialNo}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">압력(운전/설계)</TableCell>
                  <TableCell>{data?.item?.drivePressure}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">압력(운전/설계)</TableCell>
                  <TableCell>{data?.item?.designPressure}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">구매금액(천원) </TableCell>
                  <TableCell>{data?.item?.price}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">용량</TableCell>
                  <TableCell>{data?.item?.capacity}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">온도(운전/설계)⁰C</TableCell>
                  <TableCell>{data?.item?.driveTemperature}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">온도(운전/설계)⁰C</TableCell>
                  <TableCell>{data?.item?.designTemperature}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">점검 정비 절차서 </TableCell>
                  <TableCell>해당없음</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">관련도서(인증서) </TableCell>
                  <TableCell>해당없음</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">관련P&ID</TableCell>
                  <TableCell>해당없음</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">해당없음</TableCell>
                  <TableCell>해당없음</TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </StyledDetailTable>
      </StyledDetailContainer>
      <StyledDetailContainer>
        <MWCaption title={"사진 & QR CODE"} color="#01579B" icon={<CameraAltIcon />} />
        <StyledImageBox>
          {data?.item?.picture && (
            <Box>
              <img
                src={
                  data?.item?.picture &&
                  process.env.REACT_APP_PATH_EQ_PICTURE + encodeURIComponent(data?.item?.picture)
                }
                alt=""
                style={{width: "70% ", height: "auto"}}
              />
            </Box>
          )}
        </StyledImageBox>
      </StyledDetailContainer>

      <StyledDetailContainer>
        <MWCaption title={"기기점검정비 이력기록서"} color="#01579B" icon={<HistoryEduIcon />} />
        <StyledDetailTable sx={{width: {sm: "100%"}}}>
          <Table sx={{minWidth: "1200px", overFlowX: "scroll"}}>
            <TableHead>
              <TableRow>
                <TableCell align="center" rowSpan={2}>
                  NO.
                </TableCell>
                <TableCell align="center" colSpan={5}>
                  구분
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  내용
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  시작일
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  종료일
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  소요시간
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  확인자
                </TableCell>
                <TableCell align="center" rowSpan={2}>
                  소요금액
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">기타</TableCell>
                <TableCell align="center">점검</TableCell>
                <TableCell align="center">예방</TableCell>
                <TableCell align="center">예측</TableCell>
                <TableCell align="center">고장</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.item?.workOrderList &&
                data?.item?.workOrderList.map((item, index) => (
                  <TableRow key={item.uid}>
                    {/* <TableCell align="center">{item.uid}</TableCell> */}
                    <TableCell align="center">
                      <Link to={`/workorder/view/${item.uid}`}>{index + 1}</Link>
                    </TableCell>
                    <TableCell align="center">{item.checkType === 0 ? "O" : "X"}</TableCell>
                    <TableCell align="center">{item.checkType === 1 ? "O" : "X"}</TableCell>
                    <TableCell align="center">{item.checkType === 2 ? "O" : "X"}</TableCell>
                    <TableCell align="center">{item.checkType === 3 ? "O" : "X"}</TableCell>
                    <TableCell align="center">{item.checkType === 4 ? "O" : "X"}</TableCell>
                    <TableCell>{item.requestContent}</TableCell>
                    <TableCell align="center">{`${new Date(item.startDate).getFullYear()}년 ${
                      new Date(item.startDate).getMonth() + 1
                    }월 ${new Date(item.startDate).getDate()}일`}</TableCell>
                    <TableCell align="center">{`${new Date(item.completeDate).getFullYear()}년 ${
                      new Date(item.completeDate).getMonth() + 1
                    }월 ${new Date(item.completeDate).getDate()}일`}</TableCell>
                    <TableCell align="right">{item.workedHours}</TableCell>
                    <TableCell align="center">{item.writerName}</TableCell>
                    <TableCell align="right">
                      {(item.cost * 1000).toLocaleString() + "원"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </StyledDetailTable>
      </StyledDetailContainer>
    </React.Fragment>
  );
};

export default EquipmentDetail;
